<template>
  <div class="d-flex align-center">
    <div class="w-100 text-center" v-text="formatarValor(item.qtd_no_carrinho)" />

    <v-menu open-on-hover left transition="scroll-x-reverse-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>$StoreCheck</v-icon>
        </v-btn>
      </template>

      <div class="bg-white pa-3 text-center">
        <p class="mb-1 font-14">Produto dentro do carrinho</p>
        <v-btn text small color="primary" @click="item.edicao_bloqueada = false">
          ativar edição
        </v-btn>
      </div>
    </v-menu>
  </div>
</template>

<script>
import {formatarValor} from "@/helpers";

export default {
  name: "InfoProdutoNoCarrinho",
  props: {
    item: Object
  },
  methods: {
    formatarValor: formatarValor,
  }
}
</script>

<style scoped>

</style>
